import { Component, Inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { FooterComponent } from './includes/footer/footer.component';
import { HeaderComponent } from './includes/header/header.component';
import { AppInitializerService } from './appServices/core/app-initializer.service';
import { BasicInfoService } from './appServices/basic-info/basic-info.service';
import { MatDialog } from '@angular/material/dialog';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Renderer2 } from '@angular/core';
import { environment } from '../environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from './shared/language.service';
import { LanguageSwitcherComponent } from './shared/language-switcher/language-switcher.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterLink,
    RouterOutlet,
    HeaderComponent,
    TranslateModule,
    FooterComponent,
    LanguageSwitcherComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  showConsentBanner = true;
  S3_URL = environment.S3_URL;
  tenantReady = false;
  selectedLang: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private _appInit: AppInitializerService,
    private basicInfoService: BasicInfoService,
    private titleService: Title,
    private dialog: MatDialog,
    private renderer: Renderer2,
    private languageService: LanguageService
  ) {
    this.selectedLang = this.languageService.selectedLang();
  }

  ngOnInit() {
    this._appInit.appInitializer();
    this.getBasicInfo();
    this.languageService.setLanguage(this.selectedLang);
    setTimeout(() => {
      this.tenantReady = true;
    }, 1000);
  }

  changeLanguage(lang: string) {
    this.languageService.setLanguage(lang);
    this.selectedLang = lang;
  }

  scrollToTop(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }

  getBasicInfo(): void {
    this.basicInfoService.basicInfo.subscribe(
      (res) => {
        if (res?.restaurantName) {
          this.titleService.setTitle(res.restaurantName);
        }
        if (res?.bucketName && (res.imageLink || res.darkLogo)) {
          const faviconUrl = `${this.S3_URL}${res.bucketName}/${
            res.imageLink || res.darkLogo
          }`;
          this.updateFavicon(faviconUrl);
        }
      },
      (error) => {
        console.log('Error: ', error);
      }
    );
  }

  updateFavicon(faviconUrl: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const link: HTMLLinkElement | null =
        document.querySelector("link[rel='icon']");
      if (link) {
        this.renderer.setAttribute(link, 'href', faviconUrl);
      } else {
        const newLink: HTMLLinkElement = this.renderer.createElement('link');
        this.renderer.setAttribute(newLink, 'rel', 'icon');
        this.renderer.setAttribute(newLink, 'href', faviconUrl);
        this.renderer.appendChild(document.head, newLink);
      }
    }
  }

  hideConsentBanner() {
    this.showConsentBanner = false;
  }
}
